import React from 'react';
import { useNavigate } from "react-router-dom";
import Carousel from '../components/Carousel';
import support from '../images/confirm.png';
import detail from '../images/detail.jpg';
import detailMan from '../images/detail-man.jpg';
import useInView from "../lib/useInView";



const Terms = () => {
    const navigate = useNavigate();

    const [box1Ref, box1InView] = useInView({ threshold: 0.7 });
    const [boxImgRef, boxImgInView] = useInView({ threshold: 0.5 });
    const [box7Ref, box7InView] = useInView({ threshold: 0.7 });


    return (
        <>
            <div id="hero-section">
                <div className="hero-section">
                    {/* Left Box: Text and Sub-Boxes */}
                    <div className="hero-text-container">
                        <h1 className="hero-title">
                            What you can do to protect your accounts and information.
                        </h1>
                        <p className="hero-description">
                            At Sky High, we are constantly improving our safeguards to protect you and your account. Through monitoring of our customers' accounts, we can detect fraud or unauthorized use, often before you are even aware of it. If we notice suspicious activity on your card, we may contact you by phone, text, email, or mail to confirm you have authorized a transaction. It’s important we have your current contact information so we can send you email and text alerts when we notice any unusual activity with your account.                        </p>

                        <button
                            onClick={() => navigate("/contact-us")}
                            className="delete-button">
                            Contact Support
                        </button>
                    </div>

                    {/* Right Box: Image */}
                    <div className="hero-image-container">
                        <img
                            src={support}
                            alt="Hero"
                            ref={box1Ref}
                            className={`hero-image animate__animated ${box1InView ? "custom-animation" : ""}`}
                        />
                    </div>
                </div>

                {/* Display Sliding Carousel */}
                <Carousel />
            </div>



            <div className='terms-section'>
                {/* float to the right of the image */}
                <img
                    src={detail}
                    alt="Sky High National Trust Bank"
                    ref={box7Ref}
                    className={`term-image animate__animated ${box7InView ? "animate__zoomIn" : ""}`}
                />
                <p className='term-text'>
                    <h2 className="box-title">
                        Phishing or Smishing:
                    </h2>
                    <p className="box-text">
                        Fraudsters will try to gain information that gives them access to your accounts in a number of deceitful ways including: emailing you messages intended to attract you and get you to click on a fake website, or texting messages intended to alarm you and get you to call fake call centers.
                        As always, we will never ask you to provide confidential information through text or email that are not on our website. If you received email(s) that look suspicious and appear to be from Sky High NTB, please send them to support@skyhighntb.com
                    </p>


                    <h2 className="box-title">
                        KYC Verification Document:
                    </h2>
                    <p className="box-text">
                        The KYC Verification Document will be sent to a guarantor on behalf of the owner of the account. The document should not be sent via email, it will only remain valid when the original confidential document is sent and signed by guarantor and returned to the bank. Note that the document should be returned within 28 days.
                    </p>


                    <h2 className="box-title">
                        The new International Transfer Number (ITN)
                    </h2>
                    <p className="box-text">
                        In order to protect our international community of customer , we ave developed our ITN for transactions coming up after a reactivation. This number will be the only access to international transactions, and accounts without the ITN valid will have transactions pending starting from 08/NOV/2021. Contact your support representative to get your ITN for the security of your funds.
                    </p>
                    <p className="box-text">
                        In an occasion of ret-investment, account user will have to use the option of a higher plan. If the user is already at the highest plan, then they have to deposit double of their last deposit. This is a security measure to keep the system safe and free from all forms of malware and cyber-theft. A withdrawal should never be carried out during the course of the investment stage!
                    </p>


                </p>


                {/* float to the left of the image */}
                <img
                    src={detailMan}
                    alt="Sky High National Trust Bank"
                    ref={boxImgRef}
                    className={`term-image-2 animate__animated ${boxImgInView ? "animate__zoomIn" : ""}`}
                />
                <p className='term-text'>
                    <h2 className="box-title">
                        Our Terms and Conditions
                    </h2>
                    <p className="box-text">
                        Before you can start using our online service you must agree to be bound by the conditions below. You must read the conditions before you decide whether to accept them. By using any of our features, you agree to these terms stated. We strongly recommend that you print a copy of these conditions for your reference.
                        These conditions apply to your use of our online service and in relation to any accounts. They explain the relationship between you and us in relation to our online service. You should read these conditions carefully to understand how these services work and your and our rights and obligations. If there is a conflict between these conditions and your account conditions, these conditions will apply. This means that, when you use our online service both sets of conditions will apply unless they contradict each other in which case, the relevant condition in these conditions apply.
                    </p>
                    <p className="box-text">
                        <strong> IDENTITY DETAILS:</strong> The access code we may provide you with. We advise that the details on card are entered exactly as they are on our system to prevent an issue with the KYC Team. Fixing any information as related to your KYC will result to KYC Charge stipulated by the KYC Team. This fee is obtained by calculating the amount in your account at the time of t KYC Review.
                    </p>
                    <p className="box-text">
                        Using a new account, you must make an initial personal deposit to your account before receiving any form of wire transfers, all your transactions are instant. Failure to make this initial personal deposit will require you to make a deposit equivalent to 15% of this initial deposit received from a third party or wire transfer. This is in order with the Financial Institutions Fight Against Money Laundering via Crypto, your accounts will remain unable to send out funds till this term is reached. Registering an account with us concludes the acceptance to this term, and other terms and conditions mentioned.
                    </p>

                    <p className="box-text">
                        When you use our online service you must follow the instructions we give you from time to time. You are responsible for ensuring that your computer, software and other equipment are capable of being used with our online service.
                        Our online sites are secure. Disconnection from the Internet or leaving these sites will not automatically log you off. You must always use the log off facility when you are finished and never leave your machine unattended while you are logged in. As a security measure, if you have not used the sites for more than a specified period of time we will ask you to log in again.
                    </p>
                    <p className="box-text">
                        Every time you have an issue related to wire transfer, you are expected to clear it within 2 business weeks, after which you will be demanded to make a security deposit of $1800 or its international equivalent. This is called an Acceptance Fee.
                        We may require you to provide one or more of the additional security details and/or enter your password again before we accept instructions about your account. For your protection, we occasionally check requests to move or transfer money. Therefore, some transactions may be subject to a delay of up to 24 hours whilst these checks are carried out.                    </p>
                    <p className="box-text">
                        <strong>NOTE: </strong>Sky High Trust Bank do not accept responsibility for any loss you or anybody else may suffer because any instructions or information you sent us are sent in error, fail to reach us or are distorted unless you have been the victim of fraud.
                    </p>


                </p>
            </div>


        </>
    );
}

export default Terms;
